import React from "react";
import GeneralFooter from "./GeneralFooter";

export default () => {
  return <GeneralFooter />;
};
